import { ICellRendererParams } from 'ag-grid-community';
import { KeyboardEvent, useMemo, useState } from 'react';

import { ElementType } from 'bom/enums';
import { NumberInput } from 'core/components';
import { getAgGridTableCellData, isEnterKeyPress, isTabKeyPress } from 'core/utils';

export const QuantityPerElementCell = (props: ICellRendererParams) => {
  const [value, setValue] = useState(props.value || '');

  const data = getAgGridTableCellData(props, 'quantityPerElement');

  const isRowEditable = useMemo(
    () =>
      ![ElementType.ID_OVERAGE, ElementType.ID_SHORTAGE].includes(
        data?.element?.id as ElementType
      ) && !data?.deleted,
    [data]
  );

  if (!data) {
    return null;
  }

  const updateGridValue = () => {
    props.setValue(value);

    if (data.element?.id && data.quantity) {
      props.node.setDataValue('totalQuantity', data.quantity * value);
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (isEnterKeyPress(event) || isTabKeyPress(event)) {
      updateGridValue();
    }
  };

  const rowIndex = props.node.rowIndex;

  return (
    <NumberInput
      name={`elements.${rowIndex}.quantityPerElement`}
      label={null}
      value={props.value}
      onChange={(event: { target: { value: string } }) => setValue(Number(event.target.value))}
      onKeyDown={handleKeyDown}
      onBlur={updateGridValue}
      slotProps={{
        input: {
          min: 0,
          thousandSeparator: true,
        },
      }}
      disabled={!isRowEditable}
    />
  );
};
